<template>
  <div class="form-document-container py-2 px-3">
    <div class="row">
      <div
        :class="[
          'col-12',
          { 'col-md-6': !isHealthAssistance },
          { 'col-md-4': isHealthAssistance },
        ]"
      >
        <label class="form-document-label">{{ this.label }}</label>
        <p>{{ this.labelValue }}</p>
      </div>
      <div v-if="isHealthAssistance" class="col-12 col-md-3 mt-auto">
        <p class="form-document-label">Certificado Médico</p>
      </div>
      <div
        :class="[
          'col-12',
          { 'col-md-6': !isHealthAssistance },
          { 'col-md-3': isHealthAssistance },
        ]"
      >
        <label class="form-document-label">Archivo:</label>
        <ValidationProvider
          v-slot="{ errors }"
          :name="controlName"
          :rules="rules"
        >
          <CustomFileInput
            :value="value"
            :disabled="disabled"
            :attachment-id="attachmentId"
            :name="filename"
            :on-download="downloadFile"
            :accept="'.pdf'"
            :max-size="10"
            :error="errors[0]"
            display-style="normal"
            custom-error-msg="Favor anejar documento."
            @input="$emit('input', $event)"
            @after-remove="cleanAttachmentId"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-md-2 mb-auto mt-auto">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script>
import CustomFileInput from 'CustomFileInput';
import { ValidationProvider } from 'vee-validate';
import documentsService from '@/services/documents';

export default {
  name: 'Document',
  components: {
    CustomFileInput,
    ValidationProvider,
  },
  props: {
    value: {
      type: null,
      default: null,
      required: true,
    },
    /** Establece ID de archivo adjunto */
    attachmentId: {
      type: String,
      default: null,
    },
    /** Estable el nombre en el archivo */
    filename: {
      type: String,
      default: '',
    },
    controlName: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    labelValue: {
      type: String,
      required: true,
    },
    rules: {
      type: String,
      default: '',
    },
    isHealthAssistance: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    cleanAttachmentId() {
      if (this.attachmentId) this.$emit('update:attachmentId', null);
    },
    downloadFile(attachmentId) {
      return documentsService.downloadFromServer(attachmentId);
    },
  },
};
</script>

<style scoped>
.form-document-container {
  background-color: #ffffff;
  border-radius: 0px 0px 5px 5px;
  opacity: 1;
}

.form-document-label {
  color: var(--gray);
}
</style>
